import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Button from '../../../Button';
import s from './ReloadButton.scss';
var ReloadButton = function (_a) {
    var className = _a.className, count = _a.count, onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(Button, { view: "b1", onClick: onClick, className: classnames(s['root'], className), fullWidth: false }, t('siteHeader.notificationsMenu.loadNewFeedback', {
        count: count,
    })));
};
export default ReloadButton;
//# sourceMappingURL=ReloadButton.js.map